import { FieldTitle } from '../common/index';
import React from 'react';

function DateSelect(props) {
  const { label, internalTitle, formId, required, className, placeholder } = props;
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
  const usedLabel = label.length ? <label htmlFor={forId}>{label}</label> : null;
  const today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];

  return (
    <div className={`${className} input`}>
      {usedLabel}
      <input
        type="date"
        name={internalTitle}
        id={forId}
        placeholder={required && !label.length ? `${placeholder} *` : placeholder}
        required={required}
        min={today}
      />
    </div>
  );
}

DateSelect.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  className: React.PropTypes.string
};

DateSelect.defaultProps = {
  className: 'formgroup'
};

export default DateSelect;



// WEBPACK FOOTER //
// ./components/forms/dateSelect.js